type ReconnectListener = () => void

const listeners = new Set<ReconnectListener>()

/**
 * Fires when the graphql-ws client reports a successful retry-reconnect (i.e.
 * the socket dropped and came back). Subscriptions auto-resume at the apollo
 * layer, but any events that happened during the gap were missed — listeners
 * use this hook to refetch and reconcile.
 */
export function onWsReconnect(cb: ReconnectListener): () => void {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

/** Called from the apollo-client `connected` handler when wasRetry is true. */
export function notifyWsReconnected(): void {
  for (const cb of listeners) cb()
}
